// Utility per il logging della configurazione
export const logConfiguration = () => {
  const globalConfig = window.runConfig || {};
  logger.info('🔧 Caricamento configurazione esterna...');
  logger.info('🔧 Valore environment:', globalConfig.ENVIRONMENT);
  logger.info('🔧 Valore logLevel:', globalConfig.logLevel);
  // logger.info('🔧 API Base URL:', globalConfig.api?.baseURL);
  logger.debug('🔧 Configurazione completa caricata:', globalConfig);
};

// Funzione per loggare la configurazione API combinata
export const logApiConfiguration = (fullApiConfig) => {
  logger.info('🔧 Usando configurazione API combinata:', fullApiConfig);
};

// Logger centralizzato che rispetta le variabili in configuration.js
// Calcola il livello di log effettivo in base a window.config.logLevel
const getEffectiveLogLevel = () => {
  const globalConfig = window.runConfig || {};
  const configuredLevel = (globalConfig.logLevel || '').toString().toLowerCase();

  // Mappa livelli a priorità numeriche
  const levelOrder = { off: 0, error: 1, warn: 2, info: 3, debug: 4 };

  // Se logLevel è impostato, usalo
  if (configuredLevel && levelOrder.hasOwnProperty(configuredLevel)) {
    return configuredLevel;
  }

  // Default: mostra solo error
  return 'error';
};

export const logger = {
  debug: (...args) => {
    const level = getEffectiveLogLevel();
    if (level === 'debug') console.debug(...args);
  },
  info: (...args) => {
    const level = getEffectiveLogLevel();
    if (level === 'info' || level === 'debug') console.info(...args);
  },
  warn: (...args) => {
    const level = getEffectiveLogLevel();
    if (level === 'warn' || level === 'info' || level === 'debug') console.warn(...args);
  },
  error: (...args) => {
    // Gli errori si stampano sempre, anche con off
    console.error(...args);
  }
};
